import React from "react";
import { NavLink } from "react-router-dom";

const services = [
  {
    count: "01",
    title: "3D Exterior and Interior Designs",
    flaticon: "flaticon-skyline",
    description:
      "Immerse yourself in visually stunning and immersive design concepts.",
  },
  {
    count: "02",
    title: "2D Design Planning and Structurals",
    flaticon: "flaticon-sketch-1",
    description:
      "Precision and planning converge for structurally sound designs.",
  },

  {
    count: "03",
    title: "Construction and Contract",
    flaticon: "flaticon-barrier",
    description:
      "From blueprint to reality, we oversee the entire construction process.",
  },
  {
    count: "04",
    title: "Interior Makeovers",
    flaticon: "flaticon-stairs",
    description: "Transform your spaces with our expertise in interior design.",
  },

  {
    count: "05",
    title: "Plans and Projects",
    flaticon: "flaticon-sketch",
    description:
      "We provide a range of architectural 3D modeling services to our customers...",
  },

  {
    count: "06",
    title: "Decoration",
    flaticon: "flaticon-door",
    description:
      "We combine Interior and Exterior Design services and often provide them...",
  },
];

var bgimg1 = require("./../../images/background/cross-line2.png");

class Services1 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full mobile-page-padding p-t80  p-b50 bg-gray">
          <div className="section-content">
            <div className="container">
              {/* TITLE START */}
              <div className="section-head">
                <div className="sx-separator-outer separator-left">
                  <div
                    className="sx-separator bg-white bg-moving bg-repeat-x"
                    style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                  >
                    <h3 className="sep-line-one ">All Services</h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
              <div className="row">
                {services.map((item, index) => (
                  <div
                    className="col-lg-4 col-md-6 col-sm-12 m-b30"
                    key={index}
                  >
                    <div className="sx-icon-box-wraper  icon-count-2-outer">
                      <div className="icon-count-2 bg-white">
                        <span className="icon-count-number">{item.count}</span>
                        <div className="icon-xl inline-icon m-b5 scale-in-center">
                          <span className="icon-cell">
                            <i className={item.flaticon} />
                          </span>
                        </div>
                        <div className="icon-content">
                          <h4 className="sx-tilte">{item.title}</h4>
                          <p>{item.description}</p>
                          <div className="text-left">
                            <NavLink
                              to={"/services"}
                              className="site-button-link"
                            >
                              Read More
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="hilite-title text-left p-l50 text-uppercase">
            <strong>Services</strong>
          </div>
        </div>
      </>
    );
  }
}

export default Services1;
